import { Camera } from '../../canvas/Camera';


const isValidSize = ([w, h]: [number, number]) => !isNaN(w) && !isNaN(h);

const getDimensionsFromImageElement = (file: Blob | File) => {
    return new Promise<[number, number]>((rs, rj) => {
        const fr = new FileReader();
        fr.onload = () => {
            const img = new Image();
            img.onload = () => rs([img.width, img.height]);
            img.onerror = () => rj('Image failed to load.');
            img.src = fr.result as string;
        };
        fr.onerror = () => rj('File failed to read.');
        fr.readAsDataURL(file);
    });
};

const parseSvg = (svg: string) => {
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svg, 'image/svg+xml');
    const svgScripts = svgDoc.querySelectorAll('script');
    svgScripts.forEach(x => x.parentElement!.removeChild(x));
    return svgDoc;
};

const getDimensionsFromSvg = (file: Blob | File) => {
    return new Promise<[number, number]>((rs, rj) => {
        const fr = new FileReader();
        fr.onload = () => {
            const doc = parseSvg(fr.result as string);
            const root = doc.documentElement;
            const w = parseFloat(root.getAttribute('width'));
            const h = parseFloat(root.getAttribute('height'));
            if (w && h) {
                rs([w, h]);
            }
            const vwh = (/\d+\s*\d+\s*(\d+)\s*(\d+)/.exec(root.getAttribute('viewBox')) ?? []).slice(1);
            rs([parseInt(vwh[0]), parseInt(vwh[1])]);
        };
        fr.onerror = () => rj('File failed to read.');
        fr.readAsText(file);
    });
};

export const clampDimensions = (camera: Camera, [w, h]: [number, number]): [number, number] => {
    const mw = camera.viewport.width * .75;
    const mh = camera.viewport.height * .75;
    if (w >= mw) {
        const r = h / w;
        w = mw;
        h = mw * r;
    }
    if (h >= mh) {
        const r = w / h;
        w = mh * r;
        h = mh;
    }
    return [w, h];
};

export const getDimensions = async (file: Blob | File) => {
    if (file.type.includes('svg')) {
        const size = await getDimensionsFromSvg(file);
        if (isValidSize(size)) return size;
    }
    return getDimensionsFromImageElement(file);
};
